import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { useSelector } from 'react-redux';

import Input from 'components/commons/Input';
import FileInput from 'components/commons/FileInput';
import Button from 'components/commons/Button';

import mercadoPagoImage from 'views/Checkout/assets/mercado-pago.png';

import truckImage from './assets/truck.png';

import './PaymentForm.scss';

const validate = (values) => {
  const errors = {};
  if (!values.delivery_method) {
    errors.delivery_method = 'Debe elegir un método de envío';
  }
  return errors;
};

const PaymentForm = (props) => {
  const {
    deliveryMethod, handleSubmit, onSubmit, submitting, onSecureCheckoutClick, showMPButton,
    transferInfo, dispatch, envios, hayAcuerdoConVendedor, canPay,
  } = props;

  const enviosSafe = Array.isArray(envios) ? envios : [];
  const [transfer, setTransfer] = useState(false);
  const formValues = useSelector((state) => state.form.payment);
  const comprobante = !!formValues.values ? formValues.values.comprobante ? true : false : false;

  const handleBack = () => {
    dispatch(change('payment', 'comprobante', ''));
    setTransfer(false);
  };

  return (
    <div className="container checkout-step checkout-step--payment" data-testid="payment-form">
      <div className="row">
        <div className="form-container">
          <div className="checkout-section-header">
            <div>
              <h3 className="checkout-section-title">Envío y pago</h3>
              {!canPay && (
                <div className="checkout-section-subtitle">
                  Completá tus datos de envío arriba para habilitar el pago.
                </div>
              )}

              <div className="checkout-section-subtitle">
                Vas a poder seguir tu envío en tiempo real
              </div>
              <div className="checkout-section-subtitle">
                Te vamos a enviar el link de seguimiento al email del pedido.
              </div>
            </div>
          </div>
          {!canPay && (
            <div className="checkout-inline-warning" role="status">
              Falta completar datos de envío.
            </div>
          )}
          <form className="redux-form" encType="multipart/form-data" onSubmit={handleSubmit(onSubmit)}>
            {enviosSafe.length > 0 ? enviosSafe.map((envio) => (
              <div key={envio.id} className="checkout-radio">
                <Field
                  formGroupClassName={parseInt(deliveryMethod, 10) === envio.id ? 'radio-active' : ''}
                  name="delivery_method"
                  label=""
                  component={Input}
                  type="radio"
                  value={envio.id.toString()}
                  renderRadioDiv={() => (
                    <div className="radio-button-info">
                      <div className="radio-button-image">
                        <img src={truckImage} className="truck-image" alt="envio-CABA-lenceria" />
                      </div>
                      <div className="radio-button-text">
                        <span>{envio.name}</span>
                        <span className="radio-span-subtitle">
                          {envio.monto_minimo > 0 ? `¡ENVIO GRATIS SUPERANDO LOS $${envio.monto_minimo}!` : ""}
                        </span>
                      </div>
                    </div>
                  )}
                />
              </div>))
              : <></>}
            <div className="checkout-logistics-link">
              Ver logística:{' '}
              <a href="https://qlicksrl.com/" target="_blank" rel="noreferrer">Qlicksrl</a>
            </div>
            <Field
              component={Input}
              label="Comentarios"
              isTextArea
              name="comments"
            />
            {!!hayAcuerdoConVendedor &&
              <Button
                text="Arreglar pago con el vendedor"
                type="submit"
                buttonClass="btn-block"
                disabled={!canPay || submitting}
              />
            }
            {showMPButton
              && (
                <Button
                  text={(
                    <div className="secure-checkout-button-content justify-content-center">
                      <img src={mercadoPagoImage} alt="mercado pago" height="18" />
                      {' '}
                      Pagá con tarjeta de crédito o débito de forma rápida y segura
                    </div>
                  )}
                  type="button"
                  onClick={handleSubmit(onSecureCheckoutClick)}
                  buttonClass="btn-block secure-checkout-button"
                  disabled={!canPay || submitting}
                />
              )}
          </form>
        </div>
      </div>
    </div>
  );
};

PaymentForm.defaultProps = {
  deliveryMethod: null,
  canPay: true,
  envios: [],
  onSecureCheckoutClick: () => { },
  showMPButton: false,
  hayAcuerdoConVendedor: false,
  transferInfo: null,
  dispatch: () => { },
};

PaymentForm.propTypes = {
  deliveryMethod: PropTypes.string,
  envios: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    monto: PropTypes.number,
    monto_minimo: PropTypes.number,
    calculated_by_system: PropTypes.bool,
  })),
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onSecureCheckoutClick: PropTypes.func,
  showMPButton: PropTypes.bool,
  canPay: PropTypes.bool,
  hayAcuerdoConVendedor: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  transferInfo: PropTypes.any,
  dispatch: PropTypes.func,
};

export default reduxForm({
  form: 'payment',
  validate,
})(PaymentForm);
